module.exports = __webpack_public_path__ + "static/media/camera_firefox.db2258c5.png";